import React from "react";

function ChildDentalCare() {
  return <div>Child Dental Care</div>;
}

export default ChildDentalCare;
